/** iPhone, iPad, iPod (includes iPad on iOS 13+ with desktop-style "Macintosh" UA). */
export const isIOS = () => {
    if (typeof navigator === "undefined") return false;
    const ua = navigator.userAgent;
    if (/iPad|iPhone|iPod/.test(ua)) return true;
    // iPadOS 13+: Safari may report as Mac — touch points distinguish from real Macs.
    return /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
};

/** Desktop Mac (excludes iPad reporting as Macintosh). */
export const isMacOS = () => {
    if (typeof navigator === "undefined") return false;
    const ua = navigator.userAgent;
    if (!/Macintosh|Mac OS X/.test(ua)) return false;
    return navigator.maxTouchPoints <= 1;
};

/** Safari engine — excludes Chrome, Edge, Firefox, and other WebKit shells on Mac/iOS. */
export const isSafariBrowser = () => {
    if (typeof navigator === "undefined") return false;
    const ua = navigator.userAgent;
    return /Safari/i.test(ua) && !/Chrome|Chromium|Edg|OPR|Firefox|CriOS|FxiOS|EdgiOS/i.test(ua);
};

/** Safari app on iOS (not Chrome/Firefox/Edge — those can use new tab after pop-up allow). */
export const isSafariOnIOS = () => {
    if (!isIOS()) return false;
    const ua = navigator.userAgent;
    return !/CriOS|FxiOS|EdgiOS|OPiOS|DuckDuckGo/i.test(ua);
};

/** Safari on macOS — desktop/laptop Safari (not Chrome on Mac). */
export const isSafariOnMacOS = () => isMacOS() && isSafariBrowser();

/**
 * Safari on iOS and macOS blocks reliable window.open after async API calls.
 * Use same-tab redirect; Chrome (desktop + iOS) keeps new-tab flow.
 */
export const shouldOpenStripeSameTab = () =>
    isSafariOnIOS() || isSafariOnMacOS();
